const postBlogsFooterSlider = () => {
  const blogFooterSliders = document.querySelectorAll(".post-blogs-footer__glide");

  blogFooterSliders.forEach((slider) => {
    const autoplay = slider.dataset.autoplay;
    const slides = Number(slider.dataset.slidesPerView);
    let sliderType;  

    if (slides === 1) {
      sliderType = "slider"; 
    } else {
      sliderType = "carousel";
    }
      
    
    // Check if the slider has already been initialized
    if (!slider.hasAttribute("data-initialized")) {
      new Glide(slider, {
        type: sliderType,
        startAt: 0,
        perView: 2.3,
        autoplay: 3000,
        animationDuration: 1000,
        rewind: false,
        gap: 25,
        breakpoints: {
          1200: { 
            perView: 2,
          },
          1024: { 
            perView: 1.3,
          },
        },
      }).mount();
      
      // Mark the slider as initialized
      slider.setAttribute("data-initialized", "true");
    }
  });
};

// Initialize when DOM is ready
if (document.readyState !== "loading") {
  postBlogsFooterSlider();
} else {
  document.addEventListener("DOMContentLoaded", postBlogsFooterSlider);
}
